<template>
  <div class="hideTotal">
    <!-- 搜索 -->
    <table-search
      label-width="65px"
      @search="fetchList(1)"
      @reset="handleReset"
    >
      <template v-slot:basic>
        <el-form-item
          label="日期"
          class="datePicker"
        >
          <el-date-picker
            v-model="query.date"
            is-range
            arrow-control
            type="daterange"
            range-separator="至"
            start-placeholder="起始日期"
            end-placeholder="截止日期"
            placeholder="选择时间范围"
          />
        </el-form-item>
        <el-form-item label="主体">
          <el-select
            v-model="query.marketId"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in $key.spotPurchaseSaleInquiry.organization"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </template>
    </table-search>
    <!-- 导出 -->
    <inquery-result
      :is-export="false"
      @export="toDownload"
    />
    <!-- 表格 -->
    <el-table :data="tableData">
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <af-table-column
        fixed
        prop="invoiceDate"
        label="开票日期"
      />
      <af-table-column
        fixed
        prop="mailCode"
        label="邮寄条码或收票人"
      />
      <af-table-column
        fixed
        prop="invoiceNumber"
        label="发票号码"
      />
      <af-table-column
        prop="invoiceType"
        label="发票种类"
      />
      <af-table-column
        prop="customerName"
        label="购货单位"
      />
      <af-table-column
        prop="amount"
        label="发票金额"
      />
      <af-table-column
        prop="qty"
        label="发票数量"
      />
      <af-table-column
        prop="copies"
        label="发票份数"
      />
      <af-table-column
        prop="planNumber"
        label="购销计划"
      />
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, prev, pager, next"
      :current-page.sync="currentNo"
      :total="total"
      background
      @current-change="changePage"
    />
  </div>
</template>
<script>
// 等待放开 userId 字段
import api from '@/api'
import {
  getFirstDayOfCurrentMonth
} from '@/utils/util.js'

function Query () {
  this.userId = JSON.parse(localStorage.getItem('pro__USER_INFO')).value.userId || ''
  this.marketId = '000' // 沐甜市场
  this.date = [getFirstDayOfCurrentMonth(), new Date()]
}
export default {
  name: 'InvoiceMailing',
  data () {
    return {
      query: new Query(),
      currentNo: 1,
      total: 0,
      pageSize: 10,
      tableData: [], // 表格数据
    }
  },
  mounted () {
    this.fetchList(1)
  },
  methods: {
    // 分页查询
    async fetchList (currentNo, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentNo = currentNo || this.currentNo || 1
      let param = {
        ...this.query,
        currentNo: this.currentNo,
        pageSize: this.pageSize
      }
      this.query.date = this.query.date ? this.query.date : []
      param.beginDate = this.query.date.length ? this.$dayjs(this.query.date[0]).format('YYYYMMDD') : ''
      param.endDate = this.query.date.length ? this.$dayjs(this.query.date[1]).format('YYYYMMDD') : ''
      let res = await api.othersInquiry.invoiceMailing(param)
      this.total = res.data.totalElements
      this.tableData = res.data.rows
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.fetchList(1)
    },
    // 换页
    changePage (page) {
      this.fetchList(page)
    },
    // 导出
    toDownload () {},
  }
}

</script>
